(function() {
    /**
     *
     */
    angular.module('graph').filter('thumb', function() {
        return function(url, size) {
            var x, y; [x, y] = size;

            return url.replace(
                /(\.[\w\d_-]+)$/i,
                '-' + x + 'x' + y + '$1'
            );
        };
    });

    /**
     *
     */
    angular.module('graph').filter('url', function() {
        return function(text) {

            return text.replace(
                /(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/i,
                '<a href="$1" target="_blank" rel="nofollow">$1</a>'
            );
        };
    });

    /**
     *
     */
    angular.module('graph').filter('showdown', function() {
        return function (text) {
            var converter = new showdown.Converter();

            return converter.makeHtml(text);
        }
    });

    /**
     *
     */
    angular.module('graph').filter('markdown', ['$rootScope', function($scope) {
        return function (text) {
            var html = $scope.$showdown.makeHtml(text);

            var element = angular.element(
                document.createElement('div')
            );

            element.html(html);

            angular.forEach(element.find('img'), function(img) {
                img = angular.element(img);

                var a = angular.element(
                    document.createElement('a')
                );

                a.attr(
                    'href', img.attr('src')
                );

                a.text(
                    img.attr('src')
                );

                img.replaceWith(a);
            });

            angular.forEach(element.find('a'), function (a) {
                angular.element(a).attr({
                    target  : '_blank',
                    rel     : 'nofollow'
                });
            });

            return element.html();
        }
    }]);

    angular.module('graph').filter('insecureurl', ['$sce', function ($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    }]);

    angular.module('graph').run(['$rootScope', function ($rootScope) {
        /**
         *
         * @type {{simplifiedAutoLink: boolean}}
         */
        var $options = {
            simplifiedAutoLink:                 true,
            excludeTrailingPunctuationFromURLs: true
        };

        /**
         * ShowDown Init
         *
         * @type {showdown.Converter}
         */
        $rootScope.$showdown = new showdown.Converter($options);
    }]);
})();
